<p-panel [(collapsed)]="infoCollapsed" [toggleable]="true" class="card p-0"
         styleClass="p-panel-white-header">
  <ng-template pTemplate="header">
    <div class="flex align-items-center p-2">
      <i class="pi pi-info-circle text-xl" (click)="infoCollapsed = !infoCollapsed"></i>
      <p class="ml-2 mb-0 text-xl" style="margin-top: 1px;">{{ 'common.information' | transloco }}</p>
    </div>
  </ng-template>
  <div class="flex flex-column">
    <ul class="mt-0 mb-1">
      <li class="line-height-3">{{ 'info.importSynopticFiles.format' | transloco }}</li>
      <li class="line-height-3">{{ 'info.importSynopticFiles.formatConfig' | transloco }}</li>
      <li class="line-height-3">{{ 'info.importSynopticFiles.fieldsInfo' | transloco }}</li>
      <div class="mt-2 mb-2">
        <i class="font-medium">{{ 'info.importSynopticFiles.fields.svg' | transloco }} ;
          {{ 'info.importSynopticFiles.fields.id' | transloco }} ;
          {{ 'info.importSynopticFiles.fields.operation' | transloco }} ;
          {{ 'info.importSynopticFiles.fields.configuration' | transloco }}
        </i>
      </div>
      <li class="line-height-3">{{ 'info.importSynopticFiles.infoOperation' | transloco:{allowedOperations: allowedOperations} }}</li>
      <li class="line-height-3">{{ 'info.importSynopticFiles.infoSpecial' | transloco }}</li>
    </ul>
    <div class="flex flex-row " style="margin-left: 40px">
      <p-dropdown
        styleClass="w-16rem lg:w-auto lg:max-w-20rem"
        [(ngModel)]="selectedOption"
        [options]="options | translateLabels | async"
        [placeholder]="'misc.synopticModifierTypes.empty' | transloco"
        (ngModelChange)="configSelected = JSON.stringify(generateDefaultArgs($event));"
        optionLabel="label"
        appendTo="body"
      >
        <ng-template pTemplate="selectedItem">
          <div class=""  *ngIf="selectedOption">
            <div>{{selectedOption.label}} ({{'attribute.'+ selectedOption.type | transloco }})</div>
          </div>
        </ng-template>
        <ng-template let-option pTemplate="item">
          <div class="country-item">
            <div>{{option.label}} ({{'attribute.'+ option.type | transloco }})</div>
          </div>
        </ng-template>

      </p-dropdown>
      <p-button icon="pi pi-clone" [cdkCopyToClipboard]="configSelected"
                [disabled]="selectedOption === undefined"
                (click)="selectedOption === undefined ? undefined : commonMessagesService.showCopiedToClipboardMessage()"
      ></p-button>
    </div>
  </div>
</p-panel>
<div
  (click)="fileInput.click()"
  (onFileDropped)="uploadFile($event)"
  class="flex p-4 cursor-pointer border-primary border-dashed border-1 mt-4"
  appDragDrop
>
  <div class="flex m-auto">
    <div class="w-full">
      <div class="flex upload rounded-lg shadow-sm">
        <input
          #fileInput
          [accept]="allowedFileExtensions"
          (change)="uploadFile($event.target['files'])"
          hidden
          multiple
          type="file"
        >
        <div class="m-auto">
          <div class="icon w-full flex">
            <i class="pi pi-cloud-upload m-auto" style="color: var(--primary-color); font-size: 46px;"></i>
          </div>
          <div class="text-center mt-4">
            <p>{{ 'info.importSynopticFiles.dragAndDrop' | transloco }}</p>
            <div class="flex mb-3 text-center">
              <span class="w-full" style="border-bottom: 1px solid; line-height: 0.1em"></span>
              <span class="pl-2 pr-2" style="line-height: 0.2em">{{ 'info.importSynopticFiles.or' | transloco }}</span>
              <span class="w-full" style="border-bottom: 1px solid; line-height: 0.1em"></span>
            </div>
            <button pButton class="md:mr-2 p-button-primary my-2 md:mb-0">
              {{ 'info.importSynopticFiles.chooseFiles' | transloco }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div id="svgContainer"></div>
<div class="my-3">
  <div class="pt-1">
    <div class="flex w-full align-items-center justify-content-between">
      <div class="inline mb-1">
        <h4 class="mt-1 inline">{{ 'info.importSynopticFiles.importSvg' | transloco }}</h4>
      </div>
    </div>
  </div>
  <hr>
  <p-table [value]="currentSynopticFiles" [paginator]="true" [rows]="5">
    <ng-template pTemplate="header">
      <tr>
        <th scope="col" pSortableColumn="name">
          {{ 'attribute.name' | transloco }}
          <p-sortIcon field="name"></p-sortIcon>
        </th>
        <th scope="col">
          {{ 'common.image' | transloco }}
        </th>
        <th scope="col" class="w-5rem text-right">
          {{ 'common.actions' | transloco }}
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-file let-i="rowIndex">
      <tr>
        <td>
          <span class="p-column-title bold">{{ 'attribute.name'| transloco}}</span>
          {{ file.name }}
        </td>
        <td>
          <span class="p-column-title bold">{{ 'common.image'| transloco}}</span>
          <app-synoptic-thumbnail [file]="file"></app-synoptic-thumbnail>
        </td>
        <td>
          <span class="p-column-title bold">{{ 'common.actions'| transloco}}</span>
          <div [pTooltip]="'misc.cantRemoveFileInUse' | transloco" [tooltipDisabled]="!isFileBeingUsed(file.name)"
               tooltipPosition="left">
            <button
              [disabled]="isFileBeingUsed(file.name)"
              (click)="removeSynopticFile(file)"
              pButton
              icon="pi pi-times"
              class="p-button-icon-only p-button-text ml-auto"
            ></button>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div *ngIf="currentSynopticCsvFiles.length > 0" class="mt-3">
    <div class="pt-1">
      <div class="flex w-full align-items-center justify-content-between">
        <div class="inline mb-1">
          <h4 class="mt-1 inline">{{ 'info.importSynopticFiles.importConfiguration' | transloco }}</h4>
        </div>
      </div>
    </div>
    <hr>

    <div *ngIf="currentSynopticCsvFiles.length > 0">
      <div class="overflow-auto" [ngStyle]="{'max-height': '20rem'}">
        <p-accordion>
          <p-accordionTab *ngFor="let fileData of currentSynopticCsvFiles; index as fileIndex"
                          [disabled]="fileData.fileErrors == null">
            <p-header class="w-full">
              <div class="flex align-items-center justify-content-between w-full ml-2">
                <div class="w-3rem">
                  <i *ngIf="fileData.fileErrors != null" class="pi pi-file danger-color"
                     style="font-size: 30px"></i>
                  <i *ngIf="fileData.fileErrors == null" class="pi pi-file success-color"
                     style="font-size: 30px"></i>
                </div>
                <div class="w-full flex">
                  <p class="mb-0 line-height-4">{{ fileData.file.name }}</p>
                  <p class="p-12 ml-4 mb-0 line-height-4 font-normal">{{
                      fileData.file.size / 1048576 | number:
                        '1.2-2'
                    }} MB</p>
                </div>
                <div class="w-3rem flex flex-column md:flex-row justify-content-end">
                  <button (click)="deleteAttachment(fileIndex)" pButton pRipple
                          class="p-button-rounded btn-danger-light pointer-events-auto"
                          style="cursor: pointer !important;" icon="pi pi-trash">
                  </button>
                </div>
              </div>
            </p-header>
            <p-content>
              <div *ngIf="fileData.fileErrors != null">
                <div class="my-3">
                  <h5 class="flex">
                    <i class="pi pi-times-circle align-self-center mr-2 danger-color"
                       style="font-size: 22px"></i>
                    <div>
                      {{ 'error.importCsv.wrongFileFormat' | transloco }}
                    </div>
                  </h5>
                  <ul>
                    <li *ngFor="let lineError of fileData.fileErrors?.lines">
                      {{ 'error.importCsv.cannotImportSynopticOfLine' | transloco: {line: lineError + 1} }}
                    </li>
                  </ul>
                </div>
              </div>
            </p-content>
          </p-accordionTab>
        </p-accordion>
      </div>
      <div class="p-datatable p-component p-datatable-hoverable-rows mt-3">
        <p-table [(first)]="first"
                 [(rows)]="rows"
                 [paginator]="true"
                 [responsive]="true"
                 responsiveLayout="stack"
                 breakpoint="1700px"
                 [rowsPerPageOptions]="[10,25,50]"
                 [totalRecords]="processedCsvData.length"
                 [value]="processedCsvData"
                 styleClass="p-datatable-striped"
                 dataKey="lineIdentifier">
          <ng-template pTemplate="header">
            <tr>
              <th scope="col">{{ 'info.importSynopticFiles.fieldsTitle.svg' | transloco }} (*)</th>
              <th scope="col">{{ 'info.importSynopticFiles.fieldsTitle.id' | transloco }} (*)</th>
              <th scope="col">{{ 'info.importSynopticFiles.fieldsTitle.operation' | transloco }} (*)</th>
              <th scope="col">{{ 'info.importSynopticFiles.fieldsTitle.configuration' | transloco }} (*)</th>
              <th scope="col" class="w-4rem">{{ 'attribute.state' | transloco }}</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-csvSynopticConfigData let-expanded="expanded">
            <tr>
              <td>
                <span class="p-column-title bold no-break-text">{{ 'info.importSynopticFiles.fields.svg' | transloco }}</span>
                <span *ngIf="csvSynopticConfigData.synopticData?.svg">{{ csvSynopticConfigData.synopticData?.svg}}</span>
                <span *ngIf="!csvSynopticConfigData.synopticData?.svg"></span>
              </td>
              <td>
                    <span
                      class="p-column-title bold no-break-text">{{ 'info.importSynopticFiles.fields.id' | transloco }}</span>
                <span
                  *ngIf="csvSynopticConfigData.synopticData?.id">
                      {{ csvSynopticConfigData.synopticData?.id }}</span>
                <span *ngIf="!csvSynopticConfigData.synopticData?.id"></span>
              </td>
              <td>
                <span class="p-column-title bold no-break-text">{{ 'info.importSynopticFiles.fields.operation' | transloco }}</span>
                <span
                  *ngIf="csvSynopticConfigData.synopticData?.operation">{{ csvSynopticConfigData.synopticData?.operation }}</span>
                <span *ngIf="!csvSynopticConfigData.synopticData?.operation"></span>
              </td>
              <td>
                <span class="p-column-title bold no-break-text">{{ 'info.importSynopticFiles.fields.configuration' | transloco }}</span>
                <ngx-json-viewer *ngIf="csvSynopticConfigData.synopticData?.configuration" [expanded]="false" [json]="csvSynopticConfigData.synopticData?.configuration"></ngx-json-viewer>
                <span *ngIf="!csvSynopticConfigData.synopticData?.configuration"></span>
              </td>
              <td>
                <span class="p-column-title bold no-break-text">{{ 'attribute.state' | transloco }}</span>
                <div class="flex justify-content-center">
                  <div class="pr-4" *ngIf="csvSynopticConfigData.status === 'CORRECT'">
                    <i class="pi pi-check-circle align-self-center success-color"
                       style="font-size: 22px"></i>
                  </div>

                  <div class="flex" *ngIf="csvSynopticConfigData.status === 'ERROR'">
                    <button type="button" pButton pRipple [pRowToggler]="csvSynopticConfigData"
                            class="p-button-text p-button-rounded p-button-plain">
                      <i class="pi pi-times-circle align-self-center danger-color"
                         style="font-size: 1.5rem"></i>
                      <i class="align-self-center ml-2 line-height-3"
                         [ngClass]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                         style="font-size: 0.7rem"></i>
                    </button>
                  </div>
                  <div class="pr-4" *ngIf="csvSynopticConfigData.status === 'PROCESSING'">
                    <i class="pi pi-spin pi-spinner align-self-center"
                       style="font-size: 1.5rem"></i>
                  </div>
                </div>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="rowexpansion" let-csvSynopticConfigData>
            <tr>
              <td colspan="16">
                <div class="overflow-auto" [ngStyle]="{'max-height': '15rem'}">
                  <div class="my-3" *ngFor="let propertyErrors of csvSynopticConfigData.errors | keyvalue">
                    <h5 class="flex">
                      <i class="pi pi-times-circle align-self-center mr-2 danger-color"
                         style="font-size: 1.5rem"></i>
                      <div>
                        {{ this.synopticsPropertiesErrors.getTranslation(propertyErrors.key) }}
                      </div>
                    </h5>
                    <ul>
                      <ng-container *ngFor="let error of propertyErrors.value">
                        <ng-container *ngFor="let additional of error?.params?.additionalInfo">
                          <li class="word-wrap-break">
                            {{ 'error.synopticCsv.' + additional.code | transloco: {key: additional.key} }}
                            <ng-container *ngIf="additional.value !== undefined">
                              {{'error.synopticCsv.obtainedValue' | transloco: {value: additional.value}  }}
                            </ng-container>
                          </li>
                        </ng-container>
                        <li class="word-wrap-break">
                          {{ 'error.importCsv.' + error.message | transloco: error.params }}
                        </li>
                      </ng-container>
                    </ul>
                  </div>
                </div>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="summary">
            <div class="flex align-items-center justify-content-between" *ngIf="processedCsvData.length == 0">
              {{ 'pagination.empty'| transloco }}
            </div>
            <div class="flex align-items-center justify-content-between" *ngIf="processedCsvData.length > 0">
              {{ 'pagination.showing' | transloco }} {{ first + 1 }}
              {{ 'pagination.to' | transloco }} {{ (first + rows) >= processedCsvData.length ? processedCsvData.length : (first + rows) }}
              {{ 'pagination.of' | transloco }} {{ processedCsvData.length }}
              {{ (processedCsvData.length > 1 ? 'pagination.entries' : 'pagination.entry') | transloco }}
            </div>
          </ng-template>

        </p-table>
        <div class="flex flex-auto justify-content-end mt-2">
          <p-button class="w-full sm:w-auto" styleClass="w-full sm:w-auto" [disabled]="isAllCsvChecked() || !existAFileWithErrors()" [label]="'info.importSynopticFiles.saveConfig' | transloco" [icon]="'pi pi-cog'" iconPos="left" (onClick)="validateAndApplyConfig()" [loading]="validatingConfig"></p-button>
        </div>
      </div>
    </div>
  </div>
</div>


